const { $ } = window;

$(() => {
  $('.search-filter').on('change', function callback() {
    const $this = $(this);
    const query = window.location.search;

    const a = location.search.split('&');
    const paramObj = a.reduce(
      (o, v) => {
        const kv = v.split('=');
        kv[0] = kv[0].replace('?', '');
        o[kv[0]] = kv[1];
        return o;
      },
      {},
    );

    const value = $this.val();
    const param = $this.attr('name');

    if (value) {
      paramObj[param] = value;
    } else {
      delete paramObj[param];
    }

    let queryString = '';
    for (const param in paramObj) {
      queryString += `${param}=${paramObj[param]}&`;
    }

    queryString = queryString.substring(0, queryString.length - 1);

    window.location = `${window.location.origin}${window.location.pathname}?${queryString}`;
  });
});
